import { PaginatedRequest } from '@/types';

import { TrackingIconFilter, TrackingIconSlot } from '../models';
import { useGetTrackingIconsQuery } from '../services';

interface UseTrackingIconsProps {
  filters: TrackingIconFilter;
  slot: TrackingIconSlot;
  paginated: PaginatedRequest;
}

const useTrackingIcons = ({
  filters,
  slot,
  paginated,
}: UseTrackingIconsProps) => {
  const { data, isLoading, isFetching, error } = useGetTrackingIconsQuery({
    paginated,
    filters,
    slot,
  });

  const totalItems = data?.count ?? 0;

  return {
    trackingIcons: data?.items ?? [],
    totalItems,
    totalPages: totalItems ? Math.ceil(totalItems / paginated.pageSize) : 0,
    isLoading,
    isFetching,
    error,
  };
};

export default useTrackingIcons;
